import React from "react";
import ToolDescriptionCard from "./ToolDescriptionCard";
import SamplePortfolio from "../../assets/sample-pro-portfolio.png";
import { logEvent } from "helpers/analytics";
import { useHistory } from "react-router";

export default function SkilledWorkersPortfolioView() {
  const navigate = useHistory().push;

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14">
      <div className="w-full h-full">
        <img
          className="w-full h-[283px]  lg:h-full"
          src={SamplePortfolio}
          alt="LaborPass"
        />
      </div>
      <div className="h-full">
        <ToolDescriptionCard
          title="LaborPass"
          actionText="Showcase your work"
          actionTextWidthPercentage="55%"
          description="Create a professional website that highlights your skills, certifications, and completed projects making it easier to win over high-paying clients."
          ctaText="Learn more"
          handleCTAClick={() => {
            logEvent("skilled_workers_landing_page_cta_click", {
              interest: "portfolio_website",
            });

            navigate("/laborpass");
          }}
        />
      </div>
    </div>
  );
}
